var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ding_use"
  }, [_c('div', [_c('Back', {
    attrs: {
      "text": _vm.detail.name
    }
  })], 1), _c('div', {
    staticClass: "contain"
  }, [_c('RadioGroup', {
    staticClass: "synchronous",
    on: {
      "on-change": _vm.onChangesynchronous
    },
    model: {
      value: _vm.synchronous,
      callback: function ($$v) {
        _vm.synchronous = $$v;
      },
      expression: "synchronous"
    }
  }, [_c('Radio', {
    staticClass: "radio",
    attrs: {
      "label": "F"
    }
  }, [_vm._v(` ${$t("cqtx7a4", "手动同步")} `), _c('Poptip', {
    attrs: {
      "trigger": "hover",
      "transfer": ""
    }
  }, [_c('Icon', {
    staticClass: "help_icon",
    attrs: {
      "type": "ios-help-circle-outline"
    }
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(` ${$t("1lmjh716", "更新iWork侧的数据，不会修改钉钉中的通讯录数据；iWork中的多余数据会同时存在")} `)])], 1)], 1), _c('Radio', {
    staticClass: "radio",
    attrs: {
      "label": "T"
    }
  }, [_vm._v(` ${$t("gqes0n4", "自动同步")} `), _c('Poptip', {
    attrs: {
      "trigger": "hover",
      "transfer": ""
    }
  }, [_c('Icon', {
    staticClass: "help_icon",
    attrs: {
      "type": "ios-help-circle-outline"
    }
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(` ${$t("vvzm9cu", "勾选后，iWork内修改通讯录内容，会实时同步更新钉钉通讯录")} `)])], 1)], 1)], 1), _c('div', {
    staticClass: "time"
  }, [_vm._v($t("awxqac7", "上次同步时间："))]), _c('div', [_vm._v(_vm._s(_vm.time ? _vm.time.modifyDatetime : $t("k4g1", "无")))]), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "width": "116px"
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "long": "",
      "type": "primary",
      "disabled": _vm.disabled,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.asyncDing
    }
  }, [_vm._v(_vm._s(_vm.loading ? $t("xffibe6", "同步中...") : $t("ow8xgj6", "获取钉钉数据")))])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };